import { loader } from '@/components/Loader.js';
import { VehicleTask } from "../Pages/VehicleTasksPage";
import {appNotification} from '@/components/AppNotification.js';
import { user } from '@/components/User';

// кнопка создания технологической работы
// для страницы vehicle/tasks
const technologicalTaskButtonClick = (event) => {
    const btn = event.target;
    if (!btn) return;
    // Проверяем, не заблокирована ли уже кнопка
    if (btn.classList.contains('disabled')) {
        return;
    }

    const taskName = btn.dataset.taskName;
    const duration = btn.dataset.duration;

    if (!taskName || !duration) return;

    btn.disabled = true;
    btn.classList.add('disabled');

    CreateWorkModalContainer.open(taskName, duration);
}


export const VehicleNumberBlock = function (data = {}) {
    CreateWorkModalContainer.data = data;
    const technologicalTasks = data.technologicalTasks || [];
    if (!user.has('state.vehicleNumber'))
        return null;
    // кнопки планирования технологических работ
    return m(".d-flex.flex-wrap.gap-2.bg-info.p-2",
        m(".bg-info.text-center", m.trust('Транспорт: ' + user.get('state.vehicleNumber'))),
        technologicalTasks.map((item) => {
            return m(`button.btn.btn-sm.btn-warning.[type='button']` +
                `[data-task-name='${item.TaskName}']` +
                `[data-duration='${item.Duration}']`, {
                onclick: technologicalTaskButtonClick,
                disabled: item.AlreadyPlanned
            }, item.ButtonName);
        })
    );
}

const handleCreateWork = async () => {

    try {
        loader.show();
        const vehicleId = user.get('state.vehicle');
        if (!vehicleId) {
            throw new Error('Не указан тип транспортного средства');
        }

        await m.request({
            method: 'POST',
            url: `/api/create-technological-work`,
            data: {
                taskName: CreateWorkModalContainer.taskName,
                duration: parseInt(CreateWorkModalContainer.duration)
            },
            extract: (response) => {
                CreateWorkModalContainer.response = response;
                if (response.status !== 200) {
                    CreateWorkModalContainer.error = response.message ?? (response.status + ' ' + response.statusText);
                    return '{}';
                } else {
                    CreateWorkModalContainer.error = null;
                    return response.responseText;
                }
            }
        });

        CreateWorkModalContainer.close();
    } finally {
        loader.hide();
    }
};

const CreateWorkModalContainer = {
    container: null,
    modalContainerId: "#create-work-modal-container",
    taskName: null,
    duration: null,
    error: null,
    data: null,
    response: null,

    open: function (taskName, duration) {
        this.taskName = taskName;
        this.duration = duration;
        CreateWorkModalContainer.container = document.querySelector(this.modalContainerId);
        if (!CreateWorkModalContainer.container) {
            CreateWorkModalContainer.container = document.createElement("div");
            CreateWorkModalContainer.container.id = this.modalContainerId;
            document.body.appendChild(CreateWorkModalContainer.container);
            m.mount(CreateWorkModalContainer.container, m.component(CreateWorkModal));
        }
        appNotification.stop();
        m.redraw();
    },

    close: function () {
        m.mount(CreateWorkModalContainer.container, null);
        document.body.removeChild(CreateWorkModalContainer.container);
        CreateWorkModalContainer.container = null;
        CreateWorkModalContainer.taskName = null;
        CreateWorkModalContainer.duration = null;
        appNotification.reset();
        VehicleTask.init(false);
    },

    redraw: function () {
        m.redraw();
    }
};

const CreateWorkModal = {
    view: function () {
        return m('.popup',
            m(".popup-content[style='border-radius:0.5rem;']",
                m(".d-flex.flex-column.justify-content-between[style='min-height:40vh;']", [
                    m(".px-5.pb-3[style='border-bottom:1px solid #00000033']",
                        m('h3', `Требуется подтверждение`)
                    ),
                    m('.p-5', [
                        m('h4.px-2', `На технику будет создана работа`),
                        m("h4.bg-info.py-1.px-2[style='font-weight:bold;']", CreateWorkModalContainer.taskName),
                        m('h4.px-2', m.trust(`длительностью <span class='bg-info px-1 py-0' style='font-weight:bold;'>${CreateWorkModalContainer.duration}</span> минут`))
                    ]
                    ),
                    CreateWorkModalContainer.error
                        ? m('.mx-5.alert.alert-danger', CreateWorkModalContainer.error)
                        : null,
                    m(".d-flex.gap-3.px-5.py-5[style='border-top:1px solid #00000033']", [
                        m("button.btn.btn-primary[type='button'][style='flex-grow:1']", {
                            onclick: handleCreateWork
                        }, 'ОК'),
                        m("button.btn.btn-danger[type='button'][style='flex-grow:1']", {
                            onclick: () => CreateWorkModalContainer.close()
                        }, 'Отмена')
                    ])
                ])
            )
        );
    }
}